function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.175736 5.17574C0.410051 4.94142 0.78995 4.94142 1.02426 5.17574L2.6 6.75147L4.17574 5.17574C4.41005 4.94142 4.78995 4.94142 5.02426 5.17574C5.25858 5.41005 5.25858 5.78995 5.02426 6.02426L3.02426 8.02426C2.78995 8.25858 2.41005 8.25858 2.17574 8.02426L0.175736 6.02426C-0.0585787 5.78995 -0.0585787 5.41005 0.175736 5.17574Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.02422 3.02422C4.7899 3.25853 4.41 3.25853 4.17569 3.02422L2.59995 1.44848L1.02422 3.02422C0.789901 3.25853 0.410002 3.25853 0.175687 3.02422C-0.0586276 2.7899 -0.0586277 2.41 0.175687 2.17569L2.17569 0.175687C2.41 -0.0586274 2.7899 -0.0586274 3.02421 0.175687L5.02422 2.17569C5.25853 2.41 5.25853 2.7899 5.02422 3.02422Z",
  fill: "#738BA5"
});

function SvgSortingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/SortingIcon.6b548775.svg";
export { ForwardRef as ReactComponent };